import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import { Button } from "../../myfin_v2/elements/Button";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import {
  getPopulateFSDetailsApiHandler,
  mapReceivableDisclosureApiHandler,
  mapInvestmentDisclosureApiHandler,
  mapPayableDisclosureApiHandler,
  mapLoanDisclosureApiHandler,
  mapLeaseDisclosureApiHandler,
  mapFixedAssetDisclosureApiHandler,
  mapSaleDisclosureApiHandler,
  mapPurchaseDisclosureApiHandler
} from "../../WorkSpace/Components/ApiServices/apiHandler";

const MapRegModal = ({
  setMapRegModal,
  mapCategory,
  setMapCategory,
  selInvestmentRegCY,
  selInvestmentRegPY,
  selRecRegCY,
  selRecRegPY,
  selPayRegCY,
  selPayRegPY,
  selLoanRegCY,
  selLoanRegPY,
  selLoanPrecedingYear,
  selLeaseRegCY,
  selLeaseRegPY,
  selFixedAssetsRegCY,
  selFixedAssetsRegPY,
  selSalesRegCY,
  selSalesRegPY,
  selPurchaseRegCY,
  selPurchaseRegPY,
}) => {
  const [category, setCategory] = useState([{}]);
  const [notes, setNotes] = useState([{}]);
  const [selNote, setSelNote] = useState(null);

  const project_id = localStorage.getItem("project_id");

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      projectID: project_id,
    };
    getPopulateFSDetailsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          catData.forEach((obj) => {
            setNotes((prev) => [
              ...prev,
              { label: obj.particular, value: obj },
            ]);
          });
        }
      })
      .catch((error) => {
        setNotes([{}]);
      });
  };

  useEffect(() => {
    setNotes([{}]);
    console.log("category", category);

    if (category === "BS notes" || category === "PL notes" || category === "disclosure" ) {
      getPopulateFS(category);
    }
  }, [category]);

  const handleConfirmMapping = (mapCategory) => {
     if (mapCategory === "investment") {
      const recInvestmentCY = Object.values(selInvestmentRegCY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recInvestmentPY = Object.values(selInvestmentRegPY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

     const params = {
      category: category === "disclosure" ? "disclosures" : category,
      parentID: selNote._id,
      projectID: project_id,
    }; 
      const payload = {
        currentYear: recInvestmentCY,
        previousYear: recInvestmentPY,
      };
      mapInvestmentDisclosureApiHandler(params, payload)
        .then((response) => {
          if (response?.data?.success === true) {
            setMapRegModal(false);
            swal("Data mapped successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to map data",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to map data",
            "error"
          );
        });
    }
    if (mapCategory === "receivable") {
      const recRegCY = Object.values(selRecRegCY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recRegPY = Object.values(selRecRegPY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const params = {
        category: category,
        parentID: selNote._id,
        projectID: project_id,
      };
      const payload = {
        currentYear: recRegCY,
        previousYear: recRegPY,
      };
      mapReceivableDisclosureApiHandler(params, payload)
        .then((response) => {
          if (response?.data?.success === true) {
            setMapRegModal(false);
            swal("Data mapped successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to map data",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to map data",
            "error"
          );
        });
    }
    if (mapCategory === "payable") {
      const recPayableCY = Object.values(selPayRegCY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recPayablePY = Object.values(selPayRegPY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const params = {
        category: category,
        parentID: selNote._id,
        projectID: project_id,
      };
      const payload = {
        currentYear: recPayableCY,
        previousYear: recPayablePY,
      };
      mapPayableDisclosureApiHandler(params, payload)
        .then((response) => {
          if (response?.data?.success === true) {
            setMapRegModal(false);
            swal("Data mapped successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to map data",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to map data",
            "error"
          );
        });
    }

    if (mapCategory === "loans") {
      const recLoansCY = Object.values(selLoanRegCY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recLoansPY = Object.values(selLoanRegPY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recLoansPrecedingYear = Object.values(selLoanPrecedingYear)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const params = {
        category: category,
        parentID: selNote._id,
        projectID: project_id,
      };
      const payload = {
        currentYear: recLoansCY,
        previousYear: recLoansPY,
        precedingYear: recLoansPrecedingYear,
      };

      mapLoanDisclosureApiHandler(params, payload)
        .then((response) => {
          if (response?.data?.success === true) {
            setMapRegModal(false);
            swal("Data mapped successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to map data",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to map data",
            "error"
          );
        });
    }

    if (mapCategory === "lease") {
      const recLeaseCY = Object.values(selLeaseRegCY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recLeasePY = Object.values(selLeaseRegPY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const params = {
        category: category,
        parentID: selNote._id,
        projectID: project_id,
      };
      const payload = {
        currentYear: recLeaseCY,
        previousYear: recLeasePY,
      };
      
      mapLeaseDisclosureApiHandler(params,payload)
        .then((response) => {
          if (response?.data?.success === true) {
            setMapRegModal(false);
            swal("Data mapped successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to map data",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to map data",
            "error"
          );
        });
    }

    if (mapCategory === "fixed_assets") {
      const recFACY = Object.values(selFixedAssetsRegCY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recFAPY = Object.values(selFixedAssetsRegPY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const params = {
        category: category,
        parentID: selNote._id,
        projectID: project_id,
      };
      const payload = {
        currentYear: recFACY,
        previousYear: recFAPY,
      };
      mapFixedAssetDisclosureApiHandler(params,payload)
        .then((response) => {
          if (response?.data?.success === true) {
            setMapRegModal(false);
            swal("Data mapped successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to map data",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to map data",
            "error"
          );
        });
    }


    if (mapCategory === "sales") {
      const recSalesCY = Object.values(selSalesRegCY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recSalesPY = Object.values(selSalesRegPY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const params = {
        category: category,
        parentID: selNote._id,
        projectID: project_id,
      };
      const payload = {
        currentYear: recSalesCY,
        previousYear: recSalesPY,
      };
      mapSaleDisclosureApiHandler(params,payload)
        .then((response) => {
          if (response?.data?.success === true) {
            setMapRegModal(false);
            swal("Data mapped successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to map data",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to map data",
            "error"
          );
        });
    }

    if (mapCategory === "purchase") {
      const recPurchaseCY = Object.values(selPurchaseRegCY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const recPurchasePY = Object.values(selPurchaseRegPY)
        .flat()
        .map((item) => item?.data?._id)
        .filter(Boolean);

      const params = {
        category: category,
        parentID: selNote._id,
        projectID: project_id,
      };
      const payload = {
        currentYear: recPurchaseCY,
        previousYear: recPurchasePY,
      };
      mapPurchaseDisclosureApiHandler(params,payload)
        .then((response) => {
          if (response?.data?.success === true) {
            setMapRegModal(false);
            swal("Data mapped successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to map data",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to map data",
            "error"
          );
        });
    }
  };
  return (
    <Modal
      width={"35%"}
      minHeight={"350px"}
      title="Map"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          <CloseIcon
            onClick={() => {
              setMapRegModal(false);
            }}
          />
        </>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setMapRegModal(false);
            }}
            label="Cancel"
          />
          <span>
            &ensp;
            <Button
              btnColor={buttoncss.primary}
              label="Confirm Mapping"
              onClick={() => {
                handleConfirmMapping(mapCategory);
              }}
            />
          </span>
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <Dropdown
          label="Category"
          options={[
            { label: "Balance Sheet", value: "BS notes" },
            { label: "PL", value: "PL notes" },
            { label: "Disclosures", value: "disclosure" },
          ]}
          onSelect={(e) => {
            setCategory(e.value);
          }}
          placeHolder={"Select Category"}
        />
        <Dropdown
          label="Notes"
          options={notes}
          onSelect={(e) => {
            setSelNote(e.value);
          }}
          placeHolder={"Select Notes"}
        />
      </div>
    </Modal>
  );
};

export default MapRegModal;
